export default __webpack_public_path__ + "static/media/asami-kato.ca0a87f1.png";